<template>
  <div class="role-container">
    <h2>角色管理</h2>
    <div class="content">
      这里是角色管理页面的内容
    </div>
  </div>
</template>

<script>
export default {
  name: 'RoleManagement'
}
</script>

<style lang="scss" scoped>
.role-container {
  background: #fff;
  padding: 20px;
  border-radius: 4px;
  
  .content {
    margin-top: 20px;
  }
}
</style>